import { render, staticRenderFns } from "./majorityReport.vue?vue&type=template&id=0e9b8264&"
import script from "./majorityReport.vue?vue&type=script&lang=js&"
export * from "./majorityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports